import { Toggle } from '@unified-checkout/design-system';

import type { IToggle } from 'libs/design-system/src/types/Toggle/toggle';

import styles from './ToggleCard.module.scss';

const ToggleCard = ({
  title,
  toggleProps,
  onClickHandler,
}: {
  title: string;
  toggleProps: IToggle;
  onClickHandler?: () => void;
}) => {
  return (
    <div className={styles['settings-card-info__toggle']}>
      <div onClick={onClickHandler}>
        <Toggle {...toggleProps} />
      </div>
      <p className={styles['settings-card-info__toggle-text']}>{title}</p>
    </div>
  );
};

export default ToggleCard;
